import { Box, Typography } from '@mui/material';
import React from 'react';
import { numberSeparator } from 'number-separator-js';
import { FundraisingHistory } from '@/types/models';
import timeFormat from '@/utils/timeFormat';
const FundraisingHistoryItem = ({
  data,
  index
}: {
  data: FundraisingHistory;
  index: number;
}) => {
  const texts = {
    platform: 'سکوی تأمین مالی',
    amount: 'مبلغ تأمین مالی',
    completionDate: 'تاریخ تکمیل تأمین مالی',
    duration: 'دوران مشارکت',
    fixedProfit: 'سود پیش بینی شده',
    fixedProfitPreValue: 'سود سالیانه',
    month: 'ماه',
    preValue: 'تومان'
  };
  return <Box sx={{
    display: 'flex',
    flexDirection: 'column',
    borderRadius: 'var(--corner_radius_m)',
    gap: 'var(--spacing_xs)',
    border: '1px solid ',
    borderColor: 'stroke.stroke2'
  }} data-sentry-element="Box" data-sentry-component="FundraisingHistoryItem" data-sentry-source-file="FundraisingHistoryItem.tsx">
      <Box sx={{
      display: 'flex',
      flexDirection: 'row',
      gap: 'var(--spacing_xs)',
      alignItems: 'baseline',
      p: 'var(--spacing_m)',
      borderBottom: '1px solid ',
      borderColor: 'stroke.stroke2',
      width: '100%'
    }} data-sentry-element="Box" data-sentry-source-file="FundraisingHistoryItem.tsx">
        <Typography sx={{
        bgcolor: 'primaryBrand.bg5',
        color: 'primaryBrand.text',
        borderRadius: '50%',
        border: '1px solid',
        borderColor: 'primaryBrand.stroke',
        width: 24,
        height: 24,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        paddingTop: '3px'
      }} variant='bodyStrong__Wallfund' data-sentry-element="Typography" data-sentry-source-file="FundraisingHistoryItem.tsx">
          {index + 1}
        </Typography>

        <Typography sx={{
        width: 'calc(100% - 28px)'
      }} variant='bodyLargeMedium__Wallfund' color={'text.text'} data-sentry-element="Typography" data-sentry-source-file="FundraisingHistoryItem.tsx">
          {data.title}
        </Typography>
      </Box>

      <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      p: 'var(--spacing_m)',
      gap: 'var(--spacing_xxs)'
    }} data-sentry-element="Box" data-sentry-source-file="FundraisingHistoryItem.tsx">
        <Box sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        p: 'var(--spacing_xxs)',
        alignItems: 'center'
      }} data-sentry-element="Box" data-sentry-source-file="FundraisingHistoryItem.tsx">
          <Typography variant='captionMedium__Wallfund' color={'text.text2'} data-sentry-element="Typography" data-sentry-source-file="FundraisingHistoryItem.tsx">
            {texts.platform}
          </Typography>

          <Typography variant='bodyMedium__Wallfund' color={'text.text'} data-sentry-element="Typography" data-sentry-source-file="FundraisingHistoryItem.tsx">
            {data.platform}
          </Typography>
        </Box>

        <Box sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        p: 'var(--spacing_xxs)',
        alignItems: 'center'
      }} data-sentry-element="Box" data-sentry-source-file="FundraisingHistoryItem.tsx">
          <Typography variant='captionMedium__Wallfund' color={'text.text2'} data-sentry-element="Typography" data-sentry-source-file="FundraisingHistoryItem.tsx">
            {texts.amount}
          </Typography>

          <Typography variant='bodyMedium__Wallfund' color={'approve.text'} data-sentry-element="Typography" data-sentry-source-file="FundraisingHistoryItem.tsx">
            {numberSeparator({
            text: (+data.amount).toString()
          })}{' '}
            {texts.preValue}
          </Typography>
        </Box>

        <Box sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        p: 'var(--spacing_xxs)',
        alignItems: 'center'
      }} data-sentry-element="Box" data-sentry-source-file="FundraisingHistoryItem.tsx">
          <Typography variant='captionMedium__Wallfund' color={'text.text2'} data-sentry-element="Typography" data-sentry-source-file="FundraisingHistoryItem.tsx">
            {texts.completionDate}
          </Typography>

          <Typography variant='bodyMedium__Wallfund' color={'text.text'} data-sentry-element="Typography" data-sentry-source-file="FundraisingHistoryItem.tsx">
            {data.completionDate && timeFormat(new Date(data.completionDate))}
          </Typography>
        </Box>

        <Box sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        p: 'var(--spacing_xxs)',
        alignItems: 'center'
      }} data-sentry-element="Box" data-sentry-source-file="FundraisingHistoryItem.tsx">
          <Typography variant='captionMedium__Wallfund' color={'text.text2'} data-sentry-element="Typography" data-sentry-source-file="FundraisingHistoryItem.tsx">
            {texts.duration}
          </Typography>

          <Typography variant='bodyMedium__Wallfund' color={'text.text'} data-sentry-element="Typography" data-sentry-source-file="FundraisingHistoryItem.tsx">
            {data.duration} {texts.month}
          </Typography>
        </Box>

        <Box sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        p: 'var(--spacing_xxs)',
        alignItems: 'center'
      }} data-sentry-element="Box" data-sentry-source-file="FundraisingHistoryItem.tsx">
          <Typography variant='captionMedium__Wallfund' color={'text.text2'} data-sentry-element="Typography" data-sentry-source-file="FundraisingHistoryItem.tsx">
            {texts.fixedProfit}
          </Typography>

          <Typography variant='bodyMedium__Wallfund' color={'text.text'} data-sentry-element="Typography" data-sentry-source-file="FundraisingHistoryItem.tsx">
            {data.fixedProfit} % {texts.fixedProfitPreValue}
          </Typography>
        </Box>
      </Box>
    </Box>;
};
export default FundraisingHistoryItem;